import { Box, Button, Icon, Text, useDisclosure } from "@chakra-ui/react";
import PublishMyOrderModal from "./PublishMyOrderModal";
import { HiOutlineLockClosed, HiOutlineUsers } from "react-icons/hi";

const MyReadingOrderSharing = ({ readingOrder }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box bg="gray.700" p="6" borderRadius="lg" mt="2">
      <Text fontSize="sm" color="gray.400" mb="2">
        SHARING OPTIONS
      </Text>
      <Text fontWeight="bold" pb="3">
        {readingOrder.privacyMode === 1 ? (
          <>
            <Icon as={HiOutlineUsers} /> Shared with the Redwing community
          </>
        ) : (
          <>
            <Icon as={HiOutlineLockClosed} /> Private (Only you can see it)
          </>
        )}
      </Text>
      <Button variant="outline" onClick={() => onOpen()}>
        Change Visibility
      </Button>
      <PublishMyOrderModal
        isOpen={isOpen}
        onClose={onClose}
        readingOrder={readingOrder}
      />
    </Box>
  );
};

export default MyReadingOrderSharing;
